/** UI texts: market. Each key must exist in both languages. */
export const market = {
  en: {
    // Markets list
    "mkt.list.noResults": "No results.",
    "mkt.list.unsupported": "Unsupported type",
    // Market detail
    "mkt.support": "Support",
    "mkt.resistance": "Resistance",
  } as Record<string, string>,
  de: {
    // Markets list
    "mkt.list.noResults": "Keine Ergebnisse.",
    "mkt.list.unsupported": "Nicht unterstützter Typ",
    // Market detail
    "mkt.support": "Unterstützung",
    "mkt.resistance": "Widerstand",
  } as Record<string, string>,
};
